import React from 'react';

import {
  Modal,
  Button,
  // FormControl,
  // FormGroup,
  // ControlLabel,
  // Col,
  Row,
  // Well
} from 'react-bootstrap';


// import DeleteBtnWithConfirm from '../../../commonComponents/DeleteBtnWithConfirm';
// import RequiredMark from '../../../commonComponents/RequiredMark';
import DropDownMenu from '../../../commonComponents/DropDownMenu';

import custJqAjax from '../../../commonJS/custJqAjax';

export default class KeyPartStockModalCt extends React.Component {
  constructor(props) {
    super(props);
    this.handlers = {
      onChange: (selection, id, cb) => {
        const selectedItem = selection.value;

        this.setState({ selectedItem });

      },
      saveKeyPart: () => {
        const targetModel = this.props.productId,
          sourceModel = this.state.selectedItem;

        let formData = new FormData();

        formData.append('source_model_id', sourceModel);
        formData.append('target_model_id', targetModel);

        custJqAjax({
          type: 'POST',
          url: `/api/W_SaleSky_ProductItemSpecUnit_Clone_Post.php`,
          data: formData,
          processData: false,
          contentType: false,
          success: res => {
            this.props.refreshSolutionData(targetModel);
            this.funcs.closeModal();
          }
        });
      },
      getValidationState: value => (value === 'default' || !value) ? 'error' : null,
    }

    this.funcs = {
      closeModal: () => {
        this.props.parentStateHandler({ states: 'showKeyPartStockModal', newValues: false });
      },
      optsGenerator: arr => {
        if (!arr) return [];
        let opts = arr.map((item, ind) => {
          return { value: item.id, label: item.name }
        });
        return opts;
      }
    }


    this.state = {
      // optsSort: [],
      // sort: 0,
      optsKeyPart: [],
      selectedItem: '',
      // common
      btnSaveDisable: true
      // btnDeleteDisable: true,
      // onEdit: this.props.keyPartEditMode === 'edit' ? true : false,
      // onCopy: false,
      // editMode: "View",
      // editPermission: true
    }
  }


  componentDidMount() {
    // 產生keyparts選項
    const optsKeyPart = this.funcs.optsGenerator(this.props.filteredKeyPartsList);

    this.setState({ optsKeyPart });
    document.getElementById('sel-key-part-list').focus();
  }

  componentDidUpdate() {
    // 資料驗證ok才可送出
    if (this.state.selectedItem.length === 0) {
      if (!this.state.btnSaveDisable) this.setState({ btnSaveDisable: true });
    } else if (this.state.btnSaveDisable) this.setState({ btnSaveDisable: false });
  }

  render() {

    let saveBtn = "",
      // deleteBtn = "",
      // editable = 1,
      // modeBtns = "",
      // productId = "",
      saveBtnText = '儲存';

    // if(this.props.params) productId = this.props.params.productId;
    // else  productId = this.props.productId;

    saveBtn = (
      <Button disabled={this.state.btnSaveDisable}
        onClick={() => { this.handlers.saveKeyPart(this.state.onEdit ? 1 : 0) }}
        style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>
        {saveBtnText}
      </Button>
    );

    // deleteBtn = this.state.onEdit ? 
    //               <DeleteBtnWithConfirm
    //                 style={{float: "right", marginLeft: 5, position: "relative", zIndex: "3"}}
    //                 onClick={this.handlers.deleteProduct}
    //                 title="Are you sure?" />
    //             : "";


    return (
      <Modal id="modal-key-part-stock" keyboard={false} backdrop="static" show={true} onHide={this.funcs.closeModal} bsSize="large">
        <Modal.Header>
          <Modal.Title>
            <span style={{ padding: "6px 0px", height: 34, lineHeight: '34px' }}>
              <span>
                從其他產品複製規格
              </span>
            </span>
            <Button onClick={this.funcs.closeModal} style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>取消</Button>
            {saveBtn}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Row>

            <DropDownMenu
              id='sel-key-part-list'
              sm={12}
              required={false}
              label="請選擇複製來源產品"
              value={this.state.selectedItem}
              stateName="selectedItem"
              onChange={this.handlers.onChange}
              options={this.state.optsKeyPart} />

          </Row>

        </Modal.Body>
        <Modal.Footer>
          {/*
          <Button onClick={this.funcs.closeModal} style={{float: 'right', marginLeft: 5, position: "relative", zIndex: "3"}}>取消</Button>
          {saveBtn}
        */}
        </Modal.Footer>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/salesky/routes/product/ProductStockModalCt.jsx